var _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCancelTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recent-time-search-reload-time",
    style: {
      enableBackground: "new 0 0 14.947 13"
    },
    viewBox: "0 0 14.947 13",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.447,0C5.441,0,2.911,2.055,2.172,4.832L0.895,2.276L0,2.724l2.268,4.536L6.747,3.9l-0.6-0.8L3.055,5.419  C3.559,2.902,5.785,1,8.447,1c3.033,0,5.5,2.467,5.5,5.5S11.48,12,8.447,12v1c3.584,0,6.5-2.916,6.5-6.5S12.031,0,8.447,0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.947,3.5 7.947,6.768 11.17,8.916 11.725,8.084 8.947,6.232 8.947,3.5 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelTimer);
export default __webpack_public_path__ + "static/media/iconCancelTimer.e56c42500776133f5929d33ad77bb0b1.svg";
export { ForwardRef as ReactComponent };